import { useState, useEffect } from 'react';
import { ReactComponent as RiCheckMark } from '@/assets/icons/ri-checkmark-line.svg';
import { ReactComponent as IcGreenCircle } from '@/assets/icons/ic_green_circle.svg';
import { getShortDateFormat } from '@/utils';

const Timebox = ({
	court,
	hour,
	selectedField,
	selectedSchedules,
	selectedDay,
	setSelectedField,
	setSelectedSchedules,
	price,
	hideEmptyPrice = false,
	calendarWeeklyItems = [],
	weeksCount = 1
}: TimeboxWeeklyProps) => {
	const [isActive, setIsActive] = useState(false);
	let timeboxBgColor = '';
	if (isActive) {
		timeboxBgColor = 'flex bg-red-primary';
	}
	if (hideEmptyPrice && price === undefined) {
		timeboxBgColor = 'flex bg-grey-soft';
		// items-center  justify-center 
	}
	const isTimeboxSelected = () =>
		selectedSchedules[selectedDay]?.find(
			(schedule) =>
				schedule.court.id === court.id &&
				schedule.hour === hour &&
				(schedule.day === selectedDay || schedule.selectedDay === selectedDay),
		);

	useEffect(() => {
		if (isTimeboxSelected()) {
			setIsActive(true);
			return;
		}
		setIsActive(false);
	}, [selectedDay]);

	useEffect(() => {
		const newSchedule = {
			court,
			hour,
			selectedDay,
		};
		if (selectedField.includes(court.id)) {
			setIsActive(true);
			if (!isTimeboxSelected()) {
				const scheduledDate = selectedSchedules[selectedDay] || [];
				const payload = [...scheduledDate, newSchedule];
				const sched = { ...selectedSchedules };
				sched[selectedDay] = payload;
				setSelectedSchedules(sched);
			}
		} else {
			if (isTimeboxSelected()) {
				setIsActive(true);
				return;
			}
			setIsActive(false);
		}
	}, [selectedField, selectedSchedules]);
	return (
		<div
			className={`flex flex-col flex-grow items-start p-2 h-12 border border-grey-line-subtle text-white relative ${timeboxBgColor}`}
			key={hour}
			role="button"
			tabIndex={0}
			onClick={() => {
				if (hideEmptyPrice && price === undefined) return;
				const conflictedPrice = (price * calendarWeeklyItems.length)
				const totalPrice = (price * weeksCount)
				const newSchedule = {
					court,
					hour,
					selectedDay,
					totalPrice,
					conflictedPrice
				};
				const scheduledDate = selectedSchedules[selectedDay] || [];
				const payload = isActive
					? scheduledDate?.filter(
							(schedule) =>
								schedule.court.id !== court.id ||
								schedule.hour !== newSchedule.hour
					  )
					: [...scheduledDate, newSchedule];
				const sched = { ...selectedSchedules };
				sched[selectedDay] = payload;
				setSelectedSchedules(sched);
				setIsActive(!isActive);
				if (selectedField.includes(court.id)) {
					setSelectedField(selectedField.filter((field) => field !== court.id));
				}
			}}
			onKeyDown={() => {}}
		>
			{isActive && <div className='m-auto'><RiCheckMark /></div>}
			{calendarWeeklyItems.length > 0 && 
				<div className='flex flex-row align-bottom absolute left-2 top-1 h-4 w-full'>
					{	calendarWeeklyItems.map((item) => 
						<div className='group mr-1 '> 
							<IcGreenCircle/> 
							<div className='absolute text-xs hidden group-hover:block rounded bg-green-secondary p-1 mt-1'>
								{  getShortDateFormat (item, 'id-ID', 
									{
										month: 'short',
										day: 'numeric',
										year: 'numeric'
									}
								) } 
							</div>
						</div>
						)
					}
				</div>
			}
		</div>
	);
};

export default Timebox;
